import { widths, heights } from '@olist/styled-system';
import styled, { css } from 'styled-components';
import { focusContainer } from '../../utils/focusContainer.js';
import '../../utils/opacityDisabled.js';
import Caption from '../Text/Caption/Caption.js';
import '../Text/DetailedSubheading/DetailedSubheading.js';
import '../Text/OverlineLg/OverlineLg.js';
import '../Text/OverlineMd/OverlineMd.js';
import '../Text/ParagraphLg/ParagraphLg.js';
import '../Text/ParagraphMd/ParagraphMd.js';
import '../Text/SectionHeading/SectionHeading.js';
import '../Text/SectionSubheading/SectionSubheading.js';
import '../Text/Title/Title.js';

const Wrapper = styled.div `
  @media (max-width: 592px) {
    display: none;
    &:last-child {
      display: block;
    }
  }
`;
const ControlHeight = styled.div(({ theme: { olist: { components: { dropdown }, }, }, }) => css `
    position: fixed;
    z-index: 9001;

    overflow: hidden;
    border-radius: ${dropdown.content.radius};
    box-shadow: ${dropdown.content.shadow};

    ${!top &&
    css `
      opacity: 0;
    `}
  `);
const DropdownHeader = styled.div(({ theme: { olist: { components: { dropdown }, }, }, }) => css `
    padding: ${dropdown.item.padding};
    margin-bottom: ${dropdown.content['margin-top']};

    border-bottom: 1px solid ${dropdown.divider['border-color']};
  `);
const Menu = styled.ul(({ isSubMenu, theme: { olist: { components: { dropdown }, }, }, }) => {
    const defaultWidth = isSubMenu
        ? dropdown.content.width.subMenu
        : dropdown.content.width.default;
    return css `
      width: ${defaultWidth};

      margin: 0;
      box-sizing: border-box;
      overflow-x: hidden;
      overflow-y: auto;

      padding: ${dropdown.content.padding};

      background-color: ${dropdown.content['background-color']};
      border-radius: ${dropdown.content.radius};

      list-style: none;

      li + li {
        margin-top: ${dropdown.content['margin-top']};
      }
      ${widths}
      ${heights}
    `;
});
const ItemWrapper = styled.div(({ theme: { olist: { components: { dropdown }, }, }, }) => css `
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    box-sizing: border-box;

    ${Caption} {
      color: ${dropdown.item.caption.color};
    }
  `);
const Link = styled.a(({ disabled, theme: { olist: { components: { dropdown }, }, }, }) => css `
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${dropdown.item.gap};
    width: 100%;
    box-sizing: border-box;

    border: none;
    background-color: ${dropdown.item['background-color'].rest};

    padding: ${dropdown.item.padding};
    border-radius: ${dropdown.item.radius};

    color: ${dropdown.item.color};
    font-family: ${dropdown.item['font-family']};
    font-size: ${dropdown.item['font-size']};
    font-weight: ${dropdown.item['font-weight']};
    line-height: ${dropdown.item['line-height']};
    text-align: left;
    text-decoration: none;

    cursor: pointer;

    > svg {
      flex-shrink: 0;
      color: ${dropdown.item.icon.color};
    }

    ${disabled
    ? css `
          opacity: 0.4;
          cursor: not-allowed;
        `
    : css `
          &:hover {
            background-color: ${dropdown.item['background-color'].hover};
          }

          ${focusContainer({ visible: true }) `
            background-color: ${dropdown.item['background-color'].hover};
          `}

          &:active {
            background-color: ${dropdown.item['background-color'].active};
          }
        `}
  `);
const Divider = styled.hr(({ theme: { olist: { components: { dropdown }, }, }, }) => css `
    box-sizing: border-box;

    border: none;
    border-bottom: 1px solid ${dropdown.divider['border-color']};
  `);
const BackButton = styled.button(({ theme: { olist: { components: { dropdown }, }, }, }) => css `
    width: 100%;
    display: flex;
    align-items: center;
    box-sizing: border-box;

    background-color: ${dropdown.backButton['background-color']};
    border: none;
    padding-top: ${dropdown.backButton['padding-top']};
    padding-bottom: ${dropdown.backButton['padding-bottom']};
    margin-bottom: ${dropdown.backButton['margin-bottom']};

    font-size: ${dropdown.backButton['font-size']};
    font-family: ${dropdown.backButton['font-family']};
    font-weight: ${dropdown.backButton['font-weight']};
    line-height: ${dropdown.backButton['line-height']};

    color: ${dropdown.backButton.color};
    cursor: pointer;

    svg {
      margin-right: ${dropdown.backButton.icon['margin-right']};
    }
  `);

export { BackButton, ControlHeight, Divider, DropdownHeader, ItemWrapper, Link, Menu, Wrapper };
